import styled, { css } from 'styled-components';
export const Container = styled.div(({ $minWidth, $hasActions, $sortable }) => css `
    border: 1px solid var(--border-secondary);
    border-radius: var(--radius-brand);
    min-width: ${$minWidth}px;

    ${$hasActions &&
    css `
      margin-right: var(--space-n1200);
    `}

    ${$sortable &&
    css `
      margin-left: var(--space-n1200);
    `}
  `);
export const EmptyComponent = styled.div `
  margin-top: var(--space-2000);
  margin-bottom: var(--space-2000);
`;
export const EmptyMessage = styled.div `
  margin-top: var(--space-800);
  margin-bottom: var(--space-800);

  text-align: center;
`;
